const LEGACY_ORDER_CREATE_DRAFT_PREFIX = 'orderCreateDraft:v2:';

export const clearAuthLocalState = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');

  // Order-create drafts used to be stored in the browser (and later server-side
  // by the former order wizards, which are gone). Clean up any leftover
  // browser-stored drafts from older app versions so they don't linger on a
  // shared device.
  localStorage.removeItem('orderCreateDraft:v1');
  localStorage.removeItem('supplierOrderCreateDraft:v1');
  try {
    const sessionStore = window.sessionStorage;
    for (let index = sessionStore.length - 1; index >= 0; index -= 1) {
      const key = sessionStore.key(index);
      if (key && key.startsWith(LEGACY_ORDER_CREATE_DRAFT_PREFIX)) {
        sessionStore.removeItem(key);
      }
    }
  } catch {
    // sessionStorage unavailable — nothing to clean up.
  }
};
